<template>
  <div class="entrepreneur-thumbnail">
    <div class="entrepreneur-thumbnail__inner">
      <card-thumbnail :image="img" :bg="bg" />
    </div>
  </div>
</template>

<script>
import CardThumbnail from "objects/Card/CardThumbnail";
export default {
  components: {
    CardThumbnail
  },
  props: {
    img: {
      type: Object,
      required: true
    },
    bg: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.entrepreneur-thumbnail {
  /* @include sectionPaddingFull; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: var(--grid-gutter-double) var(--grid-gutter);
  @media #{$breakpoint-horizontal} {
    width: auto;
    padding: var(--grid-gutter-double) var(--grid-gutter-triple) var(--grid-gutter-double) var(--grid-gutter-double);
  }
  &__inner {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
}
</style>
